import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class UtilService {
  // ログアウトボタンがおされたときのイベント
  onClickLogoutSource = new Subject<void>();
  onClickLogout$ = this.onClickLogoutSource.asObservable();

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/providers/util.service.ts